import React from 'react'
import Layout from '../../Shared/Layout'
import CreationRfi from './CreationRfi'
import ListeRfi from './ListeRfi'
import ListeOrdreRfi from './ListeOrdreRfi'

export default function CompletRfi() {
  
  return (
    <div>
        <Layout>
            <div className="content-body default-height">
                <div className="container-fluid">
                   <CreationRfi/>
                   <ListeRfi/>
                   <ListeOrdreRfi/>
                </div>
            </div>
        </Layout>
        {/* <!--***********************************
		    Formulaire pour ajouter un Domaine
	        ***************************************--> */}
            
            

            {/* <!--***********************************
                FIN du Formulaire d'ajout du Domaine
            ***************************************--> */}
    </div>
  )
}
